import { render, staticRenderFns } from "./StudentTestLoadWidget.vue?vue&type=template&id=fc14255c"
import script from "./StudentTestLoadWidget.vue?vue&type=script&lang=js"
export * from "./StudentTestLoadWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentTestLoadWidget.vue?vue&type=style&index=0&id=fc14255c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports